import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

export const logout = async () => {
  const token = await getFromEncLocalStorage("token");
  const employeeNum = await getFromEncLocalStorage("employeenumber");
  const data = await invokeApi(endPoints.kmsLogoutApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: {
      employeenumber: employeeNum,
    },
  });

  return data;
};

const LogoutService = { logout };
export default LogoutService;
